import React from 'react'
import { I18n } from 'react-redux-i18n'

import { Container, Button, Col, Row, Modal, ModalBody, ModalFooter } from 'reactstrap'

const ModalDelete = ({ isOpenModal, setIsOpenModal, handleDeleteTemplate, id, name }) => {
  return (
    <Modal isOpen={isOpenModal} centered={true} toggle={() => setIsOpenModal(!isOpenModal)} className='modal-md'>
      <ModalBody>
        <Row>
          <Col>
            <label className={'text-center'}>
              {I18n.t('text_delete_template')}
              <h4 className='mt-3'>{name}</h4>
            </label>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Container>
          <Row noGutters>
            <Col className='text-left'>
              <Button color='primary' size={'sm'} onClick={() => setIsOpenModal(false)}>
                {I18n.t('dashboard_close')}
              </Button>
            </Col>
            <Col className='text-right'>
              <Button size={'sm'} color='danger' onClick={() => handleDeleteTemplate(id)}>
                {I18n.t('dashboard_delete')}
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFooter>
    </Modal>
  )
}

export default ModalDelete
